import axios from 'axios';
import Vue from 'vue';
import * as utils from '../../utils';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'SendSms',
  props: {
    displayDialog: {
      require: true,
      type: Boolean
    },
  },
  data: function () {
    return {
      finalText: '',
    }
  },
 created() {
  },
  methods: {
    sendSms() {
      this.$emit('sendSms', this.finalText);
      this.$emit('close');
    },
    close() {
      this.finalText = '';
      this.$emit('close');
    }
  },
 
}
